module.exports = "https://99designs-start-assets.imgix.net/js/11bb876645715e796cd31181e9191e6d.png";